module.exports = __webpack_public_path__ + "static/media/download-banner.f044be76.jpg";